import Job from "src/components/job";

export default function Jobs() {
    return (
        <div className="w-11/12 max-w-7xl mx-auto">
            <Job />
        </div>
    )
};
